import React, { useRef, useState, useEffect } from 'react';
import SearchField from './searchField/CustomSearchField';
import CalendarFilter from './TableFilters/CalendarFilter';
import DropDownFilter from './TableFilters/DropDownFilter';

interface IOrderTableFilter {
  searchCustomerName: string | undefined;
  setSearchCustomerName: (e: any) => void;
  searchPid: string | undefined;
  setSearchPid: (e: any) => void;
  kitterItems: string[];
  handleKitterApply: (e: any, z?: any) => void;
  sourceItems: string[];
  handleSourceApply: (e: any, z?: any) => void;
  selectedSourceItems: string[];
  setSelectedSourceItems: (s: string[]) => void;
  statusItems: string[];
  handleStatusApply: (e: any) => void;
  selectedDate: Date | Date[] | null | any;
  setSelectedDate: (e: Date | Date[] | null | any) => void;
  handleClearFilters: any;
  selectedStatusItems: string[];
  selectedKitterItems: string[];
  setSelectedStatusItems: (s: string[]) => void;
  setSelectedKitterItems: (s: string[]) => void;
  email: string | undefined;
  setEmail: (e: any) => void;
  phone: string | undefined;
  setPhone: (e: any) => void;
  clearSignal?: number;
  dateClearSignal?: number;
}

const OrderTableFilters: React.FC<IOrderTableFilter> = ({
  searchCustomerName,
  searchPid,
  statusItems,
  handleKitterApply,
  handleStatusApply,
  kitterItems,
  sourceItems,
  handleSourceApply,
  selectedSourceItems,
  setSelectedSourceItems,
  setSearchPid,
  setSearchCustomerName,
  selectedDate,
  setSelectedDate,
  handleClearFilters,
  selectedKitterItems,
  selectedStatusItems,
  setSelectedKitterItems,
  setSelectedStatusItems,
  email,
  setEmail,
  phone,
  setPhone,
  clearSignal = 0,
  dateClearSignal = 0,
}) => {
  const [searchKitter, setSearchKitter] = useState<string>('');
  const [searchStatus, setSearchStatus] = useState<string>('');
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const [isClearDate, setIsClearDate] = useState<boolean>(false);
  const [kitterDropdownOpen, setKitterDropdownOpen] = useState<boolean>(false);
  const [searchSource, setSearchSource] = useState<string>('');
  const [sourceDropdownOpen, setSourceDropdownOpen] = useState<boolean>(false);
  const handleClearSearch = (slug: string) => {
    if (slug === 'customerName') setSearchCustomerName('');
    if (slug === 'pid') setSearchPid('');
    if (slug === 'email') setEmail('');
    if (slug === 'phone') setPhone('');
  };

  const clearFilters = () => {
    setIsClearDate(true);
    setSearchKitter('');
    setSearchStatus('');
    setSearchSource('');
    setSelectedKitterItems([]);
    setSelectedStatusItems([]);
    setSelectedSourceItems([]);
    handleClearFilters();
    setTimeout(() => setIsClearDate(false), 1000);
  };

  useEffect(() => {
    if (clearSignal) clearFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearSignal]);

  useEffect(() => {
    if (dateClearSignal) {
      setIsClearDate(true);
      setTimeout(() => setIsClearDate(false), 1000);
    }
  }, [dateClearSignal]);

  const dropdownRef = useRef<HTMLDivElement>(null);
  const kitterDropdownRef = useRef<HTMLDivElement>(null);
  const sourceDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        sourceDropdownRef.current &&
        !sourceDropdownRef.current.contains(event.target as Node)
      ) {
        setSourceDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setDropdownOpen(false);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        kitterDropdownRef.current &&
        !kitterDropdownRef.current.contains(event.target as Node)
      ) {
        setKitterDropdownOpen(false);
      }
    };

    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <tr className="filter-row">
      <th>
        <SearchField
          search={searchPid}
          setSearch={setSearchPid}
          clearSearch={handleClearSearch}
          slug="pid"
          placeholder="PID"
        />
      </th>
      <th>
        <div className="filter-pair">
          <SearchField
            search={searchCustomerName}
            setSearch={setSearchCustomerName}
            clearSearch={handleClearSearch}
            slug="customerName"
            placeholder="Customer"
          />
          <SearchField
            search={email}
            setSearch={setEmail}
            clearSearch={handleClearSearch}
            slug="email"
            placeholder="Email"
          />
        </div>
      </th>
      <th>
        <SearchField
          search={phone}
          setSearch={setPhone}
          clearSearch={handleClearSearch}
          slug="phone"
          placeholder="Phone"
        />
      </th>
      <th />
      <th />
      <th>
        <DropDownFilter
          label="Source"
          searchItems={sourceItems}
          handleApply={handleSourceApply}
          selectedItems={selectedSourceItems}
          setSelectedItems={setSelectedSourceItems}
          search={searchSource}
          setSearch={setSearchSource}
          dropdownRef={sourceDropdownRef}
          dropdownOpen={sourceDropdownOpen}
          setDropdownOpen={setSourceDropdownOpen}
        />
      </th>
      <th>
        <CalendarFilter
          selectedDate={selectedDate}
          setSelectedDate={setSelectedDate}
          isClearFilter={isClearDate}
        />
      </th>
      <th>
        <DropDownFilter
          label="Status"
          searchItems={statusItems}
          handleApply={handleStatusApply}
          selectedItems={selectedStatusItems}
          setSelectedItems={setSelectedStatusItems}
          search={searchStatus}
          setSearch={setSearchStatus}
          dropdownRef={dropdownRef}
          dropdownOpen={dropdownOpen}
          setDropdownOpen={setDropdownOpen}
        />
      </th>
      <th>
        <DropDownFilter
          label="Kitter"
          searchItems={kitterItems}
          handleApply={handleKitterApply}
          selectedItems={selectedKitterItems}
          setSelectedItems={setSelectedKitterItems}
          search={searchKitter}
          setSearch={setSearchKitter}
          dropdownRef={kitterDropdownRef}
          dropdownOpen={kitterDropdownOpen}
          setDropdownOpen={setKitterDropdownOpen}
          alignRight
        />
      </th>
    </tr>
  );
};

export default OrderTableFilters;
